import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog/dialog-ref';
import { DialogData } from '../../../domain/common.model';
import { ContactData, EmailData } from '../../../domain/document.model';
import { Offer } from '../../../domain/offer.domain';

export namespace DialogAction {

    export class CloseAll {
        static readonly type = 'DialogAction.CloseAll';
    }

    export class AddDialogRef {
        static readonly type = 'DialogAction.AddDialogRef';

        constructor(public ref: MatDialogRef<any>) {
        }
    }

    export class OpenGeneric {
        static readonly type = 'DialogAction.OpenGeneric';

        constructor(public data: DialogData) {
        }
    }

    export class OpenDialogHttpError {
        static readonly type = 'DialogAction.OpenDialogHttpError';

        constructor(public response: HttpErrorResponse) {
        }
    }

    export class OpenFailedRouting {
        static readonly type = 'DialogAction.OpenFailedRouting';

        constructor(public url: string) {
        }
    }

    export class OpenLocationDialog {
        static readonly type = 'DialogAction.OpenLocationDialog';

        constructor(public offerId: number, public location: string) {
        }
    }

    export class OpenContactDataDialog {
        static readonly type = 'DialogAction.OpenContactDataDialog';

        constructor(public calculationId: number, public data: ContactData) {
        }
    }

    export class OpenEmailDialogData {
        static readonly type = 'DialogAction.OpenEmailDialogData';

        constructor(public calculationId: number, public data: EmailData) {
        }
    }
}
